export default __webpack_public_path__ + "static/media/RubikMonoOne-Regular.dd2a0eee.ttf";